import type { Task } from 'fhir/r4';
import React from 'react';
import { Tab, TabPane } from 'semantic-ui-react';
import type { FlatPractitioner } from 'types';

import TaskNote from '../notes';

import ActivityTab from './activityTab';
import { TabsContainer } from './tabs.styles';

type TaskDetailTabsProps = {
  taskpayload: Task;
  foodRecommendationNotes: string;
  orderId: string;
  flatPractitioners: FlatPractitioner[];
  refresh: (data?: Task, shouldRevalidate?: boolean) => Promise<Task>;
  /** `Patient.id` from the fetched patient — absent until that fetch resolves. */
  patientId: string | undefined;
  /** `Patient.managingOrganization` — absent for a patient with no managing org. */
  orgId: string | undefined;
  setLoader: React.Dispatch<React.SetStateAction<boolean>>;
  loader: boolean;
  setRenderURL: (value: boolean) => void;
};

const TaskDetailTabs: React.FC<TaskDetailTabsProps> = ({
  flatPractitioners,
  foodRecommendationNotes,
  loader,
  orderId,
  setLoader,
  refresh,
  setRenderURL,
  taskpayload,
  patientId,
  orgId,
}) => {
  if (!taskpayload) return null;

  const panes = [
    {
      menuItem: { key: 'comments', color: 'teal', content: 'Comments', icon: 'chat', name: 'Comments' },
      render: () => (
        <TabPane>
          {taskpayload && (
            <TaskNote
              taskpayload={taskpayload}
              foodRecommendationNotes={foodRecommendationNotes}
              orderId={orderId}
              flatPractitioners={flatPractitioners}
              refresh={refresh}
              patientId={patientId}
              orgId={orgId}
              setLoader={setLoader}
              loader={loader}
              setRenderURL={setRenderURL}
            />
          )}
        </TabPane>
      ),
    },
    {
      menuItem: { key: 'activity', color: 'teal', content: 'Activities', icon: 'list', name: 'Activities' },
      render: () => <TabPane>{taskpayload && <ActivityTab taskId={taskpayload.id} />}</TabPane>,
    },
  ];

  return (
    <TabsContainer>
      <Tab menu={{ secondary: true, pointing: true }} panes={panes} />
    </TabsContainer>
  );
};

export default TaskDetailTabs;
